import { constants } from '@yola/subscription-manager-js';
import introDiscountsCoupons from '../constants/intro-discounts-coupons';

const { B2C_HOSTING_BRONZE, B2C_HOSTING_SILVER, B2C_HOSTING_GOLD } = constants.SubscriptionType;

const getPromoCoupon = (type, term) => {
  const planType = [B2C_HOSTING_GOLD, B2C_HOSTING_SILVER, B2C_HOSTING_BRONZE].find((plan) =>
    type.includes(plan)
  );

  return (planType && introDiscountsCoupons[planType]?.[term]) || '';
};

export default getPromoCoupon;
